import { useMemo } from "preact/hooks";
import useUserConsent from "./useUserConsent";
import useAppState from "./useAppState";
import { processShortcodes, handleShortcodeClick, hasShortcodes } from "helpers/processShortcodes";

export const useShortcodes = () => {
  const { acceptAll, acceptDefault, deny, acceptSelected } = useUserConsent();
  const { toggleSettingsPanel, isSettingsPanelOpen, changePanelTab } = useAppState();

  const actions = useMemo(() => ({
    acceptAll,
    acceptDefault,
    acceptSelected,
    deny,
    toggleSettingsPanel,
    changePanelTab
  }), [acceptAll, acceptDefault, acceptSelected, deny, toggleSettingsPanel, changePanelTab]);

  return {
    processText: (text: string, buttonClass?: string) => processShortcodes(text, buttonClass),
    handleClick: (event: MouseEvent) => handleShortcodeClick(event, actions, isSettingsPanelOpen),
    checkForShortcodes: (text: string) => hasShortcodes(text)
  };
};

export default useShortcodes;
